import { namespaces } from 'i18n/i18n.constants';
import React from 'react';
import { getI18n, useTranslation } from 'react-i18next';
export const FooterLegal = () => {
    const { t } = useTranslation(namespaces.common);
    const i18n = getI18n();
    return (React.createElement("div", { className: 'container' },
        React.createElement("ul", { className: 'list-inline-md text-md-end mb-0 p-2' },
            React.createElement("li", { className: 'list-inline-item me-0 me-xl-4' },
                React.createElement("div", { title: t('digitalid.footer.legalMent'), className: 'anchor cursor-pointer text-decoration-none', onClick: () => {
                        // history.push(routes.static.doc.legalMentions(buCode))
                        if (i18n.language.toLowerCase() === 'en') {
                            window.open('http://www.bankaudi.fr/france/legal-notice', '_blank', 'noreferrer');
                        }
                        else {
                            window.open('http://www.bankaudi.fr/france/french/mentions-legales', '_blank', 'noreferrer');
                        }
                    } }, t('digitalid.footer.legalMent'))),
            React.createElement("li", { className: 'list-inline-item me-0 me-xl-4' },
                React.createElement("div", { title: t('digitalid.footer.personData'), className: 'anchor cursor-pointer text-decoration-none', onClick: () => {
                        // history.push(routes.static.doc.personalData(buCode))
                        if (i18n.language.toLowerCase() === 'en') {
                            window.open('https://pwstg02.blob.core.windows.net/pwfiles/Library/Assets/Gallery/Data-Protection-France.pdf', '_blank', 'noreferrer');
                        }
                        else {
                            window.open('https://pwstg02.blob.core.windows.net/pwfiles/Library/Assets/Gallery/Data-Protection-France.pdf', '_blank', 'noreferrer');
                        }
                    } }, t('digitalid.footer.personData'))))));
};
